<template>
  <modal
    :disabled="disabled"
    :modal-heading="modalContent.heading"
    :modal-open="modalOpen"
    :toggle-modal="toggleModal"
  >
    <transition mode="out-in" name="modal-content">
      <component
        :is="modalContent.component"
        v-if="modalContent.component"
        v-bind="modalContent.properties"
      />
    </transition>
  </modal>
</template>

<script>
  import Modal from "Components/Modal.vue";
  import { sprintf } from "sprintf-js";
  import DeleteCommentContent from "./DeleteCommentContent.vue";
  import EditCommentContent from "./EditCommentContent.vue";
  import ReadCommentContent from "./ReadCommentContent.vue";
  import ShareCommentContent from "./ShareCommentContent.vue";

  export default {
    components: {
      DeleteCommentContent,
      EditCommentContent,
      Modal,
      ReadCommentContent,
      ShareCommentContent,
    },

    computed: {
      modalContent() {
        if (this.context === "share") {
          return {
            component: "share-comment-content",
            heading: this.shareHeading,
            properties: {
              changeModalContext: this.changeModalContext,
              comment: this.comment,
              deceasedName: this.deceasedName,
              isLandingPage: this.isLandingPage,
              isNew: this.isNew,
              memorialFund: this.memorialFund,
              openLightbox: this.openLightbox,
              toggleModal: this.toggleModal,
            },
          };
        }

        if (this.context === "edit") {
          return {
            component: "edit-comment-content",
            heading: this.texts.shareCommentEdit.editYourCondolence,
            properties: {
              changeModalContext: this.changeModalContext,
              comment: this.comment,
              deceasedName: this.deceasedName,
              hash: this.hash,
              possessiveName: this.possessiveName,
              toggleModal: this.toggleModal,
            },
          };
        }

        if (this.context === "read") {
          return {
            component: "read-comment-content",
            heading: sprintf(
              this.texts.singleComment.fullCondolenceHeading,
              this.comment.name
            ),
            properties: {
              comment: this.comment,
              modalOpen: this.modalOpen,
            },
          };
        }

        if (this.context === "delete") {
          return {
            component: "delete-comment-content",
            heading: this.texts.shareCommentEdit.deleteYourCondolence,
            properties: {
              commentId: this.comment.id,
              hash: this.hash,
              toggleModal: this.toggleModal,
            },
          };
        }

        return {
          component: "",
          heading: "",
          properties: null,
        };
      },
      shareHeading() {
        if (this.isNew) {
          return this.texts.shareCommentContent.condolencePublishedHeading;
        }

        if (this.isLandingPage) {
          return sprintf(
            this.texts.shareCommentContent.condolenceLandingModalHeading,
            this.comment.name
          );
        }

        return this.texts.shareCommentContent.shareThisCondolence;
      },
    },

    data() {
      return {
        texts: lavendlaObituary,
      };
    },
    name: "SingleCommentModal",

    props: {
      changeModalContext: {
        default: null,
        type: Function,
      },
      comment: {
        required: true,
        type: Object,
      },
      context: {
        default: "",
        type: String,
      },
      deceasedName: {
        default: "",
        type: String,
      },
      disabled: {
        required: true,
        type: Boolean,
      },
      hash: {
        default: "",
        type: String,
      },
      isLandingPage: {
        default: false,
        type: Boolean,
      },
      isNew: {
        default: false,
        type: Boolean,
      },
      memorialFund: {
        default: null,
        type: Object,
      },
      modalOpen: {
        required: true,
        type: Boolean,
      },
      openLightbox: {
        default: null,
        type: Function,
      },
      possessiveName: {
        default: "",
        type: String,
      },
      resetIsNew: {
        default: null,
        type: Function,
      },
      toggleModal: {
        required: true,
        type: Function,
      },
    },

    updated() {
      if (this.resetIsNew && this.isNew && !this.modalOpen) {
        this.resetIsNew();
      }
    },
  };
</script>
